import React from 'react';

function DMCAPolicy() {
  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#1a1d29', 
      color: '#e2e8f0',
      padding: '40px 20px'
    }}>
      <div className="max-w-4xl mx-auto">
        <h1 style={{ 
          fontSize: '32px', 
          fontWeight: '700', 
          color: '#e2e8f0', 
          marginBottom: '8px',
          textAlign: 'center'
        }}>
          DMCA Policy
        </h1>
        
        <p style={{ 
          fontSize: '16px', 
          color: '#9ca3af', 
          textAlign: 'center',
          marginBottom: '40px'
        }}>
          Digital Millennium Copyright Act Policy - Indian Company
        </p>

        <div style={{ 
          backgroundColor: '#242938', 
          border: '1px solid #374151',
          borderRadius: '8px',
          padding: '32px',
          lineHeight: '1.6'
        }}>
          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#e2e8f0', marginBottom: '16px' }}>
            Overview
          </h2>
          <p style={{ marginBottom: '24px', color: '#d1d5db' }}>
            Largetransfer.net is an Indian company that respects intellectual property rights and expects its users to do the same. 
            In accordance with the Digital Millennium Copyright Act (DMCA), we will respond to clear notices of alleged 
            copyright infringement that comply with the DMCA requirements.
          </p>

          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#e2e8f0', marginBottom: '16px' }}>
            Reporting Copyright Infringement
          </h2>
          <p style={{ marginBottom: '16px', color: '#d1d5db' }}>
            If you believe that your copyrighted work has been copied and is accessible on our service in a way that 
            constitutes copyright infringement, please send us a DMCA notice with the following information:
          </p>
          
          <ul style={{ marginBottom: '24px', color: '#d1d5db', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}><strong>Infringing URL:</strong> The specific URL where the infringing content is located</li>
            <li style={{ marginBottom: '8px' }}><strong>Your Name:</strong> Full legal name of the copyright owner</li>
            <li style={{ marginBottom: '8px' }}><strong>Your Address:</strong> Complete mailing address</li>
            <li style={{ marginBottom: '8px' }}><strong>Proof of Ownership:</strong> Any attachments or documents proving your ownership of the copyrighted material</li>
            <li style={{ marginBottom: '8px' }}><strong>Contact Information:</strong> Email address and phone number for communication</li>
            <li style={{ marginBottom: '8px' }}><strong>Statement:</strong> A statement that you have a good faith belief that use of the material is not authorized by the copyright owner</li>
            <li style={{ marginBottom: '8px' }}><strong>Accuracy Statement:</strong> A statement that the information in the notification is accurate and that you are authorized to act on behalf of the copyright owner</li>
          </ul>

          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#e2e8f0', marginBottom: '16px' }}>
            Contact Information
          </h2>
          <p style={{ marginBottom: '16px', color: '#d1d5db' }}>
            Please send DMCA notices to our support team:
          </p>
          
          <div style={{ 
            backgroundColor: '#1e293b',
            border: '1px solid #334155',
            borderRadius: '6px',
            padding: '20px',
            marginBottom: '24px'
          }}>
            <p style={{ marginBottom: '8px', color: '#e2e8f0', fontWeight: '500' }}>
              DMCA Support Team
            </p>
            <p style={{ marginBottom: '4px', color: '#d1d5db' }}>
              Email: support@largetransfer.net
            </p>
            <p style={{ marginBottom: '4px', color: '#d1d5db' }}>
              Subject: DMCA Copyright Infringement Notice
            </p>
            <p style={{ marginBottom: '0px', color: '#9ca3af', fontSize: '14px' }}>
              We will respond to your DMCA notice and keep you updated on the status of your complaint.
            </p>
          </div>

          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#e2e8f0', marginBottom: '16px' }}>
            Response to DMCA Notices
          </h2>
          <p style={{ marginBottom: '16px', color: '#d1d5db' }}>
            Upon receipt of a valid DMCA notice, we will:
          </p>
          
          <ul style={{ marginBottom: '24px', color: '#d1d5db', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>Promptly review the complaint and verify the information provided</li>
            <li style={{ marginBottom: '8px' }}>Remove or disable access to the allegedly infringing material if valid</li>
            <li style={{ marginBottom: '8px' }}>Notify the user who posted the material of the takedown</li>
            <li style={{ marginBottom: '8px' }}>Send you a confirmation email about the action taken</li>
            <li style={{ marginBottom: '8px' }}>Keep you updated on the status of your complaint via email</li>
          </ul>

          <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#e2e8f0', marginBottom: '16px' }}>
            Important Notes
          </h2>
          <ul style={{ marginBottom: '24px', color: '#d1d5db', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>We are an Indian company operating under Indian laws and international DMCA compliance</li>
            <li style={{ marginBottom: '8px' }}>All DMCA communications will be handled by our support team</li>
            <li style={{ marginBottom: '8px' }}>We will provide status updates via email throughout the process</li>
            <li style={{ marginBottom: '8px' }}>False or fraudulent DMCA notices may result in legal action</li>
            <li style={{ marginBottom: '8px' }}>We process DMCA notices promptly within 1-2 business days</li>
          </ul>

          <div style={{ 
            marginTop: '32px', 
            padding: '16px', 
            backgroundColor: '#1e293b',
            borderRadius: '6px',
            border: '1px solid #475569'
          }}>
            <p style={{ color: '#94a3b8', fontSize: '14px', margin: '0' }}>
              <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DMCAPolicy;
